import React from 'react';
import GlassCard from './ui/GlassCard';
import ScrollReveal from './ui/ScrollReveal';

export const Skills: React.FC = () => {
  const skillCategories = [
    {
      title: 'Backend Development',
      skills: [
        { name: 'Python', level: 85 },
        { name: 'PHP', level: 85 },
        { name: 'Django', level: 80 },
        { name: 'Node.js', level: 80 },
        { name: 'Java', level: 85 }
      ]
    },
    {
      title: 'Generative AI & Agents',
      skills: [
        { name: 'RAG Pipelines', level: 85 },
        { name: 'Agentic AI', level: 80 },
        { name: 'LangChain', level: 85 },
        { name: 'LangGraph', level: 80 },
        { name: 'Vector DBs (Pinecone/FAISS)', level: 80 }
      ]
    },
    {
      title: 'Database & DevOps',
      skills: [
        { name: 'MySQL', level: 90 },
        { name: 'Docker', level: 80 },
        { name: 'AWS', level: 75 },
        { name: 'Jenkins', level: 80 },
        { name: 'Software System Analysis', level: 80 }
      ]
    }
  ];


  return (
    <section id="skills" className="py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-ink">My Skills</h2>
          <div className="w-24 h-1 bg-brand mx-auto"></div>
          <p className="text-ink-dim mt-4 max-w-2xl mx-auto">
            Technical expertise developed through <a href="#experience" className="text-brand hover:underline">14+ years of professional experience</a>. 
            Ready to discuss your project? <a href="#contact" className="text-brand hover:underline">Contact Sudipta Dhara</a>.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {skillCategories.map((category, categoryIndex) => (
            <ScrollReveal key={categoryIndex}>
              <GlassCard>
                <h3 className="text-xl font-bold text-ink mb-6 text-center">{category.title}</h3>
                <div className="space-y-6">
                  {category.skills.map((skill, skillIndex) => (
                    <div key={skillIndex}>
                      <div className="flex justify-between mb-2">
                        <span className="font-medium text-ink">{skill.name}</span>
                        <span className="text-brand">{skill.level}%</span>
                      </div>
                      <div className="w-full bg-white/10 rounded-full h-2.5">
                        <div
                          className="bg-brand h-2.5 rounded-full"
                          style={{ width: `${skill.level}%`, transition: 'width 1.5s ease-in-out' }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </GlassCard>
            </ScrollReveal>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-6 text-center">
          {['Generative AI Engineer', 'RAG', 'Agentic AI', 'LangChain', 'LangGraph', 'OpenAI API', 'Vector DBs', 'LLM Apps'].map((tech, index) => (
            <ScrollReveal key={index}>
              <div className="rounded-lgx p-4 flex items-center justify-center transition-all hover:translate-y-[-5px] hover:shadow-lux-2 glass">
                <span className="font-medium text-ink">{tech}</span>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};
